
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorDelete as ObiCursorDeleteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-delete.js';
 
 
 

 
 export const ObiCursorDelete = createComponent({
   react: React,
   tagName: 'obi-cursor-delete',
   elementClass: ObiCursorDeleteElement,
   events: {
     
   }
  });
 
 